export default __webpack_public_path__ + "static/media/app-store-badge.f0b8ebdc.svg";